export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-4.19984960.png";